import { ConditionType } from "../interfaces/flow/condition/ConditionType";
import { ComparisonOperator } from "../interfaces/flow/condition/ComparisonOperator";

export const createCondition = (conditionType: ConditionType, options:any=undefined) => {
  switch (conditionType) {
    case ConditionType.COMBINED_CONDITION:
      return {
        type: ConditionType.COMBINED_CONDITION,
        conditions: [],
      };
    case ConditionType.DATA_CONDITION:
      return {
        type: ConditionType.DATA_CONDITION,
        value: options?.value ? options.value : "",
        jsonPath: options?.jsonPath ? options.jsonPath : "",
        operator: options?.operator ? options.operator : ComparisonOperator.EQUALS,
      };
    case ConditionType.HTTP_STATUS_CODE_CONDITION:
      return {
        type: ConditionType.HTTP_STATUS_CODE_CONDITION,
        value: options?.value ? options.value : "",
      };
    default:
      break;
  }
};
